import { RESET_APP } from '../actions';
import {
    RECIEVE_GIFT_CARD, UPDATE_AMOUNT_TO_CHARGE, RESET_GIFT_CARD, ADD_GIFT_CARD, REMOVE_GIFT_CARD, SET_GIFT_CARD_NUMBER, SET_GIFT_CARD_PIN, RESET_CURRENT_GIFT_CARD, RESET_CURRENT_AMOUNT
} from '../actions/giftCard';

// {
//   giftcard_number: '',
//   balance_remaining: 0,
//   amount_to_charge: 0
// }

const rawInitialState = {
  total_amount: 0,
  current_gift_card_amount: 0,
  current_gift_card_number: '',
  array: []
}
const initialState = () => JSON.parse(JSON.stringify(rawInitialState));

export default (state = initialState(), action) => {
  switch (action.type) {
    case RESET_CURRENT_AMOUNT:
      return {
        ...state,
        current_gift_card_amount: 0
      };
    case SET_GIFT_CARD_NUMBER:
      return {
        ...state,
        current_gift_card_number: action.giftCardNumber
      };
    case SET_GIFT_CARD_PIN:
      return{
        ...state,
        current_gift_card_pin: action.pinNumber
      };
    case RECIEVE_GIFT_CARD:
      return {
        ...state,
        current_gift_card_amount: action.balance_remaining,
        current_gift_card_number: action.giftCardNumber
      };
    case ADD_GIFT_CARD:
      const newArray = state.array;
      newArray.push({
        giftcard_number: state.current_gift_card_number,
        balance_remaining: state.current_gift_card_amount,
        amount_to_charge: action.amount
      });
      return {
        ...state,
        array: newArray,
        total_amount: state.total_amount + action.amount,
        current_gift_card_amount: 0,
        current_gift_card_number: ''
      };
    case REMOVE_GIFT_CARD:
      const newArray2 = state.array.filter(object => {
        return object.giftcard_number !== action.giftcard_number;
      });
      return {
        ...state,
        array: newArray2,
        total_amount: state.total_amount - action.amount
      };
    case UPDATE_AMOUNT_TO_CHARGE:
      return { ...state };
    case RESET_CURRENT_GIFT_CARD:
      return {
        ...state,
        current_gift_card_amount: 0,
        current_gift_card_number: ''
      };
    case RESET_GIFT_CARD:
    case RESET_APP:
      return { ...initialState() };
    default:
      return state;
  }
};
